import { useState, useEffect } from "react";
import { useConfig } from "../contexts/ConfigContext";

function useGeolocation(initializeLocation = true) {
  const { setConfig, config } = useConfig();
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    error: null,
  });

  useEffect(() => {
    if (location.latitude !== null && location.longitude !== null) {
      setConfig({
        ...config,
        metadataOptions: {
          ...config.metadataOptions,
          location: { value: location },
        },
      });
    }
  }, [location]);

  useEffect(() => {
    if (!initializeLocation) return;
    if (!navigator.geolocation) {
      setLocation({
        ...location,
        error: "Geolocation is not supported by your browser",
      });
      return;
    }

    const onSuccess = (position) => {
      setLocation({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        error: null,
      });
    };

    const onError = (error) => {
      setLocation({
        ...location,
        error: error.message,
      });
    };

    const geoOptions = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0,
    };

    if (location.latitude === null && location.longitude === null) {
      navigator.geolocation.getCurrentPosition(onSuccess, onError, geoOptions);
    }
  }, []);

  return location;
}

export default useGeolocation;
